<template>
<div class="bg-light">
  <Banner class="sticky-top bg-light" />
  <b-container>
    <b-row>
      
      <!-- Banner section -->
      
      <b-col class="order-2 order-sm-1" cols="12">
	<b-container class="px-0">           
	  <ConstructionBanner>
	    <b-img :src="require('../assets/link_icon.png')" class="p-2 p-sm-0 mb-2" style="height: 170px; width: 170px;" slot="icon"></b-img>
	    <h4 slot="icon-title">Trinity Link&trade;</h4>
	    <h4 slot="description-title"><small class="text-secondary">(Patent Pending) (coming soon)</small></h4>
	    <h4 slot="description">Conceptually Links internal file information from Trinity PDF together and to other structured data</h4>
	  </ConstructionBanner>
	</b-container>
      </b-col>
      
      <!-- Tab section -->
      
      <b-col class="order-1 order-sm-2" cols="12">
	<b-container class="px-0">      
	  <b-row>
	    <b-col>	
	      <ProductsTab activeProductTab="link" />
	    </b-col>
	  </b-row>
	</b-container>
      </b-col>
      
      <!-- Content section -->
      
      <b-col class="order-3" cols="12">
	<b-row>
	  <b-col>
	    <div class="p-2 p-lg-5 bg-white">
	      <b-container>
		<b-row class="mb-4">
		  <b-col cols="12" lg="6">
		    <ul>
		      <!--li><h3 class="mb-4" style="font-weight: 400;">Conceptually Links internal file information from Trinity PDF together and to other structured data</h3></li-->
		      <li><h3 class="mb-4" style="font-weight: 400;">Information property level version control with permissions inherited from source documents</h3></li>
		      <li><h3 class="mb-4" style="font-weight: 400;">Full featured conceptual semantic search across all project information</h3></li>
		      <li><h3 class="mb-4" style="font-weight: 400;">Conceptually map between different classification systems and work breakdown structures</h3></li>
		      <li><h3 style="font-weight: 400;">All information stored in a massively scalable semantic graph</h3></li>
		    </ul>
		  </b-col>
		  <b-col cols="12" lg="6">		  
		    <b-img :src="require('../assets/conceptual_link_graph.png')" fluid></b-img>
		  </b-col>
		</b-row>
		<b-row>
		  <b-col>
		    <b-img :src="require('../assets/link_pods_to_graph.png')" fluid></b-img>
		  </b-col>
		</b-row>
	      </b-container>
	    </div>
	  </b-col>
	</b-row>
      </b-col>
    </b-row>

  </b-container>
  <GmxFooter />
</div>
</template>

<script>
// @ is an alias to /src
const $ = require('jquery')
import * as log from 'loglevel'
import Banner from '@/components/gmx-banner.vue';
import ConstructionBanner from '@/components/construction-banner.vue';
import ProductsTab from '@/components/products-tab.vue';
import GmxFooter from '@/components/footer.vue';
export default {
    name: 'ProductsLink',
    components: {
	Banner,
	ConstructionBanner,
	ProductsTab,
	GmxFooter
    },
    methods: {
	img: function (image) {
	    require(image)
	}
    }
};
</script>

<style>
.gmx-purple {
  color: #2e145e;
}
.gmx-red {
  color: #ff0000;
}
.cover-background {
    background-image: url('../assets/toolkit_cover_background.png');
    background-repeat: no-repeat;
    background-size: cover;
}
</style>
